import './cyclo-params.sass'

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Tile from 'controls/cyclo-params/tile/Tile';
import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';
import transmit from 'actions/transmit';

const DEFAULT_EVENT = 'CHANGE_TRACK_PARAM_CHECKSTATE';

class CycloParams extends Component {
  constructor(props) {
    super(props);

    if (props.eventToDispatch) {
      this.eventToDispatch = props.eventToDispatch;
    } else {
      this.eventToDispatch = DEFAULT_EVENT;
    }
  }

  componentDidMount() {
    if (this.props.trackId && this.props.trackId !== null) {
      this.props.request(
        ['recorders', 'getCyclo'],
        'get',
        'RECORDER_CYCLO',
        { trackId: this.props.trackId }
      );
    }

    if (this.props.recorderId && this.props.recorderId !== null) {
      this.props.request(
        ['recorders', 'getCycloByRecorderId'],
        'get',
        'RECORDER_CYCLO',
        { recorderId: this.props.recorderId }
      );
    }

    if (Array.isArray(this.props.chosenAnalogParams)) {
      this.props.chosenAnalogParams.forEach((item) => {
        this.props.transmit(
          this.eventToDispatch,
          {
            ...item,
            ...{ state: true }
          }
        );
      });
    }

    if (Array.isArray(this.props.chosenBinaryParams)) {
      this.props.chosenBinaryParams.forEach((item) => {
        this.props.transmit(
          this.eventToDispatch,
          {
            ...item,
            ...{ state: true }
          }
        );
      });
    }
  }

  buildBody() {
    if (this.props.cycloFetching !== false) {
      return <ContentLoader/>
    } else {
      return <Tile
        analogParams={ this.props.recorderCyclo.analogParams }
        binaryParams={ this.props.recorderCyclo.binaryParams }
        chosenAnalogParams={ this.props.chosenAnalogParams || [] }
        chosenBinaryParams={ this.props.chosenBinaryParams || [] }
        trackId={ this.props.trackId }
        colorPickerEnabled={ this.props.colorPickerEnabled }
        eventToDispatch={ this.eventToDispatch }
      />
    }
  }

  render() {
    return <div className='cyclo-params'>
      { this.buildBody() }
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    cycloFetching: state.recorderCyclo.pending,
    recorderCyclo: state.recorderCyclo,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CycloParams);
